import { Checkbox, Paragraph, Popover, Select } from "@nn-design-system/react-component-library";
import React from "react";
import { ErrorMessage, handleShowErrorMessage } from "../../redux/reducers/claimFieldErrorsReducer";
import CustomInput from "../CustomInputs/CustomInput";
import WholeLineContainer from "../ReportFormTemplate/WholeLineContainer";

type IdentificationField =
   | "checked"
   | "identityCardType"
   | "identityCardNumber"
   | "identityCardIssuedBy"
   | "identityCardValidUntil";

type IdentificationValidationKeys = {
   identityCardType: string;
   identityCardNumber: string;
   identityCardIssuedBy: string;
   identityCardValidUntil: string;
};

type IdentificationDataBlockProps = {
   checked: boolean;
   identityCardType: string;
   identityCardNumber: string;
   identityCardIssuedBy: string;
   identityCardValidUntil: string;
   updateField: (field: IdentificationField, value: string | boolean) => void;
   validationKeys: IdentificationValidationKeys;
   helperText: string;
   fieldErrors: ErrorMessage[];
};

const identificationTooltip =
   "Při očekávané výplatě částky vyšší než 500 000 Kč je navíc nutné, aby byl podpis osoby uplatňující nárok na pojistné plnění ověřen (notářem / na obecním úřadě / na Czech POINTu / zaměstnancem NN). Za ověření se považuje také ověření totožnosti prostřednictvím datové schránky nebo elektronické podepsání dokumentu v ePodatelně s využitím služby Bank iD Sign.";

const IdentificationDataBlock: React.FC<IdentificationDataBlockProps> = ({
   checked,
   identityCardType,
   identityCardNumber,
   identityCardIssuedBy,
   identityCardValidUntil,
   updateField,
   validationKeys,
   helperText,
   fieldErrors,
}) => (
   <>
      <WholeLineContainer>
         <>
            <Checkbox
               labelText="Doplnit identifikační údaje"
               variant="Small"
               onChange={() => updateField("checked", !checked)}
               dataState={checked ? "Checked" : "NotChecked"}
               popoverElement={
                  <Popover headingText="" placement="top-start" variant="Icon">
                     <Paragraph>{identificationTooltip}</Paragraph>
                  </Popover>
               }
            />
            <Paragraph hasMargin={false}>{helperText}</Paragraph>
         </>
      </WholeLineContainer>
      {checked && (
         <>
            <Select
               labelText="Typ průkazu"
               placeholderText="Vyberte typ průkazu"
               value={identityCardType}
               options={[
                  { text: "Občanský průkaz", value: "OP" },
                  { text: "Pas", value: "Pas" },
               ]}
               validationText={handleShowErrorMessage(
                  validationKeys.identityCardType,
                  fieldErrors
               )}
               onChange={(event) =>
                  updateField("identityCardType", String(event.target.value))
               }
            />
            <CustomInput
               labelText="Číslo průkazu"
               value={identityCardNumber}
               validationText={handleShowErrorMessage(
                  validationKeys.identityCardNumber,
                  fieldErrors
               )}
               onChange={(event) =>
                  updateField("identityCardNumber", event.target.value)
               }
            />
            <CustomInput
               labelText="Vydáno"
               value={identityCardIssuedBy}
               validationText={handleShowErrorMessage(
                  validationKeys.identityCardIssuedBy,
                  fieldErrors
               )}
               onChange={(event) =>
                  updateField("identityCardIssuedBy", event.target.value)
               }
            />
            <CustomInput
               labelText="Platný do"
               value={identityCardValidUntil}
               type="date"
               validationText={handleShowErrorMessage(
                  validationKeys.identityCardValidUntil,
                  fieldErrors
               )}
               onChange={(event) =>
                  updateField("identityCardValidUntil", event.target.value)
               }
            />
         </>
      )}
   </>
);

export default IdentificationDataBlock;
